/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class RepairDialog extends _Ext.TransDialog<RepairRow, any> {
        State: any;

        protected getFormKey() { return RepairForm.formKey; }
        protected getIdProperty() { return RepairRow.idProperty; }
        protected getLocalTextPrefix() { return RepairRow.localTextPrefix; }
        protected getNameProperty() { return RepairRow.nameProperty; }
        protected getService() { return RepairService.baseUrl; }
        protected getDeletePermission() { return RepairRow.deletePermission; } x
        protected getInsertPermission() { return RepairRow.insertPermission; }
        protected getUpdatePermission() { return RepairRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }
        protected useViewMode() { return true; }

        public form = new RepairForm(this.idPrefix);
        TaxArray: any[];
        TaxRegistred: number; 
        PartyType = 0;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.RoundOff);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorToolbar(this.form.TaxDetails);
            //To Hide Image Toolbar & Label
            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            //q.hideCaption(this.form.LedgerName);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            //q.hideCaption(this.form.Posted);
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });

            // **** Get Party Details using PartyID **** 
            this.form.RepairTypeId.changeSelect2(e => {
                switch (this.form.RepairTypeId.value) {

                    case "651":
                    case "653":
                        q.showField(this.form.POSCustomerId);
                        q.hideField(this.form.PartyId);
                        break;
                    case "652":
                        q.hideField(this.form.POSCustomerId);
                        q.showField(this.form.PartyId);
                        break;


                }
            });
            this.form.PartyId.changeSelect2(e => {
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.POSCustomerId.value = "0";
            });
            this.form.POSCustomerId.changeSelect2(e => {
                this.form.ItemDetails.PartyId = parseInt(this.form.POSCustomerId.value);
                this.form.PartyId.value = "0";
            });
            this.form.PartyId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.PartyId.value)) {
                    let PartyDetails: OMS.CustomerRow;
                    OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                    this.PartyType = parseInt(PartyDetails.TaxRegType);
                    //this.form.LedgerName.value = PartyDetails.LedgerName;
                    //this.form.GstVat.value = PartyDetails.GstVat; 
                    let AddressDetails: OMS.AddressMasterRow;
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            AddressDetails = response.Entity,
                        { async: false }
                    );

                    if (AddressDetails != null) {
                        this.State = AddressDetails.StateName;
                        ////this.form.Country.value = AddressDetails.CountryName;
                        //var city = AddressDetails.CityName;
                        //let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        //    + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                        //this.form.Address1.value = address;

                    }
                    this.form.GrossAmount.value = 0;
                    this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                    this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                    this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                    this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                    this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                    this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                    this.ExchangeRate = this.form.ExchRate.value;
                }
            });

            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
                this.form.CCRoundOff.value = this.form.RoundOff.value * this.ExchangeRate;
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            });

            //this.form.CurrencyId.changeSelect2(e => {
            //    var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value
            //        && new Date(x.FromDate) <= this.form.TransDate.valueAsDate
            //        && new Date(x.ToDate) >= this.form.TransDate.valueAsDate)[0];
            //    this.form.ExchRate.value = ExchangeDetails.ExchRate;
            //    this.ExchangeRate = ExchangeDetails.ExchRate;

            //});

            //Load Image after Row in Details is Clicked
            var self = this;
            this.form.ItemDetails.slickGrid.onClick.subscribe(function (e, args) {
                var x: Serenity.UploadedFile = {
                    Filename: self.Image,
                    OriginalName: ""
                }
                self.form.ProductItemImage.value = x;
                q.setImageEditorHeight(self.form.ProductItemImage, 160);
            });

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length;
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);
            })


            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.CustomerGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Customer"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.CustomerRow[]) => {
                if (selectedItems.length > 0) {

                    //this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                    //this.form.LedgerName.value = selectedItems[0].LedgerName;

                    //this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                    //this.form.LedgerName.value = selectedItems[0].LedgerName;
                    this.RateListId = selectedItems[0].CostPricegroupId == null ? 3 : selectedItems[0].CostPricegroupId;
                    this.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                    this.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                    this.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                    this.StoneDiscount = selectedItems[0].StnAddDisc == null ? 0 : selectedItems[0].StnAddDisc;
                    this.LaborDiscount = selectedItems[0].LbrAddDisc == null ? 0 : selectedItems[0].LbrAddDisc;
                    //this.ExchangeRate = this.form.ExchRate.value;
                    //this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                    //this.form.GstVat.value = selectedItems[0].GstVat;
                    //let AddressDetails: OMS.AddressMasterRow;
                    //OMS.AddressMasterService.GetAddress({
                    //    LedgerId: parseInt(this.form.PartyId.value)
                    //},
                    //    response =>
                    //        AddressDetails = response.Entity,
                    //    { async: false }
                    //);

                    //if (AddressDetails != null) {
                    //    this.form.State.value = AddressDetails.StateName;
                    //    this.form.Country.value = AddressDetails.CountryName;
                    //    var city = AddressDetails.CityName;
                    //    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                    //        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    //    this.form.Address1.value = address;

                    //}
                }

            }
            pickerDialog.dialogOpen();

        }

        // #region Total Weight, Amount and TAX Calculation
        public CalculateAmountandTax(Items: any, TotalItems: number) {
            if (!this.isViewMode()) {

                if (this.form.ItemDetails.getItems().length > 0) {

                    q.showAndDisableField(this.form.CurrencyId);
                    q.showAndDisableField(this.form.ExchRate);
                    q.showAndDisableField(this.form.PartyId);
                }
                else {
                    q.showAndEnableField(this.form.CurrencyId);
                    q.showAndEnableField(this.form.ExchRate);
                    q.showAndEnableField(this.form.PartyId);
                }

                if (parseInt(this.form.PartyId.value) > 0 || parseInt(this.form.POSCustomerId.value) > 0) {

                    var HSN = [];
                    var Amount = [];
                    var TaxDetail = [];
                    var TaxDetail = [];
                    var ItemTotal = 0;
                    var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;
                    for (var x of Items) {
                        ntamt += x.NetAmount || 0;
                        gramt += x.GrossAmount || 0;
                        disc += x.Discount || 0;
                        pcs += x.Pieces || 0;
                        wt += x.Weight || 0;
                        nwt += x.NetWeight || 0;

                        var temp = false;
                        for (let i = 0; i < HSN.length; i++) {
                            if (HSN[i] == x.TaxCode) {
                                Amount[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            HSN.push(x.TaxCode);
                            Amount.push(x.GrossAmount);
                        }
                        ItemTotal++;
                    };

                    this.form.NetAmount.value = gramt;
                    this.form.Discount.value = disc;
                    var TaxAmount = 0;
                    var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == 19)[0].IsTaxApplicable;

                    if (ItemTotal == TotalItems && TaxApplicable) {

                        var TaxItems = this.form.TaxDetails.getItems().length;
                        var it = this.form.TaxDetails.getItems();
                        if (TaxItems > 0) {
                            this.form.TaxDetails.DeleteTax();
                        }


                        var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;
                        let partystate;
                        if (parseInt(this.form.PartyId.value) > 0) {
                            OMS.AddressMasterService.GetAddress({
                                LedgerId: parseInt(this.form.PartyId.value)
                            },
                                response =>
                                    partystate = response.Entity.StateName,
                                { async: false }
                            );
                        } else if (parseInt(this.form.POSCustomerId.value) > 0)
                            partystate = Cmpstate;

                        //TODO: Get Company Country to Call appropriate TAX Helper
                        if (this.TaxRegistred != 290 && this.TaxRegistred != 288) {
                            if (partystate == Cmpstate) {
                                TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, this.TaxRegistred);
                                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);
                            }
                            else {
                                TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, true, this.TaxRegistred);
                                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, true);
                            }

                            var temp2 = this.form.TaxDetails.getData(TaxDetail);
                            this.form.TaxDetails.view.setItems(temp2, true);
                            var self = this;

                            TaxDetail.forEach(function (value: RepairTaxRow) {
                                value.CCTaxAmount = value.TaxAmount * self.ExchangeRate;
                                if (value.TaxType != "TDS")
                                    TaxAmount += value.TaxAmount;
                                else
                                    tds += value.TaxAmount;
                            });
                        }

                        this.form.TaxAmount.value = TaxAmount;
                        this.form.GrossAmount.value = gramt + TaxAmount;
                        this.form.Pieces.value = pcs;
                        this.form.Weight.value = wt;
                        this.form.NetWeight.value = nwt;
                    }
                    else {
                        this.form.GrossAmount.value = gramt;
                        this.form.Pieces.value = pcs;
                        this.form.Weight.value = wt;
                        this.form.NetWeight.value = nwt;
                    }

                    this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                    this.form.CCTaxAmount.value = this.form.TaxAmount.value * this.ExchangeRate;
                }
            }
        }

        //#endregion



        protected onDialogOpen() {
            super.onDialogOpen();
            q.hideField(this.form.POSCustomerId);
            q.hideField(this.form.PartyId);
            var repairtype = parseInt(this.form.RepairTypeId.value);
            if (repairtype != null) {
                switch (repairtype) {

                    case 651:
                    case 653:
                        q.showField(this.form.POSCustomerId);
                        q.hideField(this.form.PartyId);
                        break;
                    case 652:
                        q.hideField(this.form.POSCustomerId);
                        q.showField(this.form.PartyId);
                        break;
                    default:
                        q.hideField(this.form.POSCustomerId);
                        q.hideField(this.form.PartyId);
                }
            }

        }

        protected afterLoadEntity() {
            super.afterLoadEntity(); 
            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0 && this.isNew) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                //this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                //var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                //this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (!Q.isEmptyOrNull(this.form.PartyId.value)) {
                q.showAndDisableField(this.form.PartyId);
                q.showAndDisableField(this.form.CurrencyId);
                q.showAndDisableField(this.form.ExchRate);
                let PartyDetails: OMS.CustomerRow;
                OMS.CustomerService.Retrieve({ EntityId: this.form.PartyId.value }, response => { PartyDetails = response.Entity }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                //this.form.LedgerName.value = PartyDetails.LedgerName;
                this.TaxRegistred = parseInt(PartyDetails.TaxRegType);
                //this.form.GstVat.value = PartyDetails.GstVat;
                var partystate = "";
                if (parseInt(this.form.PartyId.value) > 0) {
                    OMS.AddressMasterService.GetAddress({
                        LedgerId: parseInt(this.form.PartyId.value)
                    },
                        response =>
                            partystate = response.Entity.StateName,
                        { async: false }
                    );
                } else if (parseInt(this.form.POSCustomerId.value) > 0) {
                    var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;

                    partystate = Cmpstate;
                }
                this.State = partystate;

                //this.form.Country.value = AddressDetails.CountryName;
                //var city = AddressDetails.CityName;
                //let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                //    + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                //this.form.Address1.value = address;

                this.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.StoneDiscount = PartyDetails.StnAddDisc == null ? 0 : PartyDetails.StnAddDisc;
                this.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.LaborDiscount = PartyDetails.LbrAddDisc == null ? 0 : PartyDetails.LbrAddDisc;
                this.ExchangeRate = this.form.ExchRate.value;

                this.form.ItemDetails.canUpdate = 0;
            }

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Repair.RepairVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));

            var postingpermission = Q.Authorization.hasPermission('Repair:Invoice:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    RepairService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                RepairService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }
            for (var i = 0; i < this.form.ItemDetails.getItems().length; i++) {
                let items = this.form.ItemDetails.getItems();
                items[i].BOMDetails.forEach(function (x) {
                    if (x.BomRate == null || x.BomRate <= 0 || x.BomAmount == null || x.BomAmount <= 0) {
                        var msg = q.text('Message.Component.RateNotDefined', 'Rate not Defined for Component, Can not Save! </br>') + items[i].ProductCode;
                        Q.alert(msg)
                        Isvalid = false;
                    }
                })

                if (items[i].LaborDetails.length > 0) {
                    items[i].LaborDetails.forEach(function (x) {
                        if (x.LabourRate == null || x.LabourRate <= 0 || x.LabourAmount == null || x.LabourAmount <= 0) {
                            Q.alert("Rate not Defined for labor, Can not Save!")
                            Isvalid = false;
                        }
                    })
                }
            }

            return Isvalid;

        } 
        validateEntity(row: Inventory.RepairRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }

            row.ItemDetails.forEach(function (value) {

                if (value.GrossAmount == 0) {
                    Q.alert("Amount is 0 for " + value.ProductCode + " can not Save! ")
                    return false;
                }

            });
 
        }
    }
}